import React from 'react'
import { MainBanner, BannerText, BannerSec }from './Banner.style'
import DynamicTable from '../../../components/DynamicTable/DynamicTable'

const Banner = () => {
    return (
        <div>
            <MainBanner>
                <BannerSec>
                <BannerText>
                <h2>¿Quiénes somos?</h2>
                <p>HAL Smartia es una empresa de servicios especializada en identificar soluciones inteligentes a problemas complejos para nuestros clientes a partir de la intersección del análisis cuantitativo y cualitativo en el contexto de la revolución de datos.
                    Nuestro objetivo es acelerar la completa integración entre la sociedad y las herramientas digitales, de información y tecnológicas.
                    Para lograr nuestra meta, desarrollamos plataformas digitales y productos basados en tecnología de última generación en los sectores de retail, marketing, agricultura, energía, aeronaútica y exploración espacial, que sean asequibles, sustentables y útiles.</p>
                </BannerText>
                </BannerSec>
            </MainBanner>
            {/* <DynamicTable style={{width: '100px'}}/> */}
        </div>
    )
}
export default Banner